export const checkIfValidCalendlyLink = async (url: string) => {
  if (!url) return false
  if (!url.includes('calendly.com')) return false
  return true
}
